import React from 'react';

const SimpleText = props => {
  const { text } = props;

  return (
    <td className="c-app-showcase__cell c-app-showcase__cell--center-aligned">
      <p className="c-app-showcase__simple-text">{text}</p>
    </td>
  );
};

export default SimpleText;
